@if (hasAiCredit()) {
  <div class="question-credits" *transloco="let t">
    <button type="button" class="btn btn-link btn-sm p-0" [attr.aria-expanded]="expanded()" (click)="toggle()">
      {{ t('shows.credits') }}
    </button>
    @if (expanded()) {
      <div class="credits-list">
        <p>{{ t('survey.question_credits.source') }}</p>
        <dl>
          @for (row of rows(); track row.labelTranslationKey) {
            <dt>{{ t(row.labelTranslationKey) }}:</dt>
            <dd>
              @for (name of row.names; track $index) {
                {{ name.text ?? t(name.translationKey) }}@if (!$last) {, }
              }
            </dd>
          }
        </dl>
      </div>
    }
  </div>
}
